import React, { useState } from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import {
  BlueskyCustomReplyAudience,
  BlueskyReplyLevel,
} from 'redux/middleware/api/podcast-service';
import { BlueskyShareVideoOptions, BlueskySocialShareStep } from '../../types';
import BlueskyPostComposerStep from './BlueskyPostComposerStep';

export type UseBlueskyPostComposerStepConfig = {
  onShare: (options: BlueskyShareVideoOptions) => void;
};

export default function useBlueskyPostComposerStep({
  onShare,
}: UseBlueskyPostComposerStepConfig): Step<BlueskySocialShareStep> {
  const [allowQuotePost, setAllowQuotePost] = useState(true);
  const [replyLevel, setReplyLevel] = useState<BlueskyReplyLevel>('everybody');
  const [customReplyAudiences, setCustomReplyAudiences] = useState<
    BlueskyCustomReplyAudience[]
  >([]);

  const footerConfig = useSocialShareModalFooter({
    onShare: () =>
      onShare({ allowQuotePost, replyLevel, customReplyAudiences }),
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: (
      <BlueskyPostComposerStep
        {...{
          allowQuotePost,
          replyLevel,
          customReplyAudiences,
        }}
        onToggleAllowQuotePost={setAllowQuotePost}
        onReplyLevelChange={setReplyLevel}
        onChangeCustomReplyAudiences={setCustomReplyAudiences}
      />
    ),
  };
}
